import { createEffect } from 'effector'
import {
  HomeRowType,
  type HomeRow,
  type HomeRowFilters,
  type HomeRows,
  type HomeRowSorting,
} from './index.h'

export {
  HomeRowType,
  type HomeRow,
  type HomeRowFilters,
  type HomeRows,
  type HomeRowSorting,
}

export const getFx = createEffect<string, HomeRows>()
